import LoadingContainer from "@shared/ui/LoadingContainer/LoadingContainer";
import PlusIcon from "@shared/assets/icons/PlusIcon";
import clsx from "clsx";
import styles from "./Button.module.scss";

const PLUS_ICON_COLOR = {
  blue: "#fff",
  blueGradient: "#fff",
  gray: "#fff",
  blueBorder: "#0a61f5",
  border: "#5c5d64",
  redBorder: "#ed4c5c",
  transparent: "var(--text-primary)",
};

const Button = ({
  onClick,
  variant = "blue",
  children,
  isLoading = false,
  width,
  type = "button",
  disabled,
  plus = false,
  className,
}) => {
  const buttonClass = clsx(styles[variant], className);

  return (
    <button
      className={buttonClass}
      onClick={onClick}
      style={{ width }}
      type={type}
      disabled={disabled}
    >
      {isLoading ? (
        <LoadingContainer color="white" />
      ) : (
        <>
          {plus && <PlusIcon color={PLUS_ICON_COLOR[variant] ?? "#fff"} />}
          {children}
        </>
      )}
    </button>
  );
};

export default Button;
